import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmailService {
  private readonly url = environment.apiUrl;

  constructor(private http: HttpClient) {}

  sendEmail(data: any): Observable<any> {
    return this.http.post(`${this.url}/v1/email/information`, data);
  }

  schedule(data: any): Observable<any> {
    return this.http.post(`${this.url}/v1/email/schedule`, data);
  }

  sourvey(data: any): Observable<any> {
    return this.http.post(`${this.url}/v1/email/sourvey`, data);
  }

  feedback(data: any): Observable<any> {
    return this.http.post(`${this.url}/v1/email/feedback`, data);
  }

}
